// extracted by mini-css-extract-plugin
export default {"ppe-icon-actions":"Sites_ppe-icon-actions__BbDP5","edit":"Sites_edit__0LGWv","delete":"Sites_delete__WNpt8"};